<template>
  <div class="logs">
    <v-row>
      <v-col sm="12">
        <span class="headline">{{ pageName }}</span>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  components: {},
  data: () => ({
    pageName: 'Logs',
  }),
  computed: {},
  methods: {},
  async created() {},

  watch: {},
};
</script>

<style></style>
